import { useSelector } from 'react-redux';

function useUser() {
  return useSelector(state => state.loginReducer);
}

export default useUser;
